export function ourMenuSlider() {

    const $slider = $(".menu-section .menu-gallery");
    const $settings = {
        arrows: false,
        fade: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        autoplaySpeed: 500,
    };

    $slider.slick($settings);

    $('.menu-listing .tab-menu[data-slide]').click(function (e) {
        e.preventDefault();
        var slideno = $(this).data('slide');
        var name = $(this).attr('aria-controls');

		$('.tabs-slider button').removeClass('focus');
        $('.menu-listing .tab-menu').removeClass('active').attr('aria-selected', 'false');
        $(this).addClass('active').attr('aria-selected', 'true');
        $('.menu-tabs').attr({'hidden':true, 'tabindex':'-1', 'aria-hidden':true }).hide()
        $('#' + name).attr({'hidden':false, 'tabindex':0, 'aria-hidden':false }).show()
        $slider.slick('slickGoTo', slideno)
    });
	
}


// WEBPACK FOOTER //
// ./assets/js/modules/our-menu-slider.js